import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WeblinkFaultService } from '../shared/weblink-fault.service';
import {WeblinkData, WeblinkSettings} from '../shared/weblink-data/weblink-data';
import { EditableFault, FaultState } from '../shared/editable-fault/editable-fault';
import { TileLayout } from '../shared/tile-layout/tile-layout';
import { Activity } from '../../core/activity/activity';
import { WeblinkAttachmentListComponent } from '../weblink-attachment-list/weblink-attachment-list.component';
import {Status} from "../../core/status/status";


@Component({
  selector: 'app-weblink-fault-list',
  templateUrl: './weblink-fault-list.component.html',
  styleUrls: ['./weblink-fault-list.component.scss']
})
export class WeblinkFaultListComponent implements OnInit {

  data: WeblinkData;
  faults: EditableFault[];
  settings: WeblinkSettings;
  layout: TileLayout;
  selectedActivity:Activity;
  isSelected = false;
  isInEditMode = false;
  isInViewMode=false;
  isLoading = true;
  searchValue = '';


  errorMessage: string;

  files: FileList;

  @Output() onChangeUser= new EventEmitter();
  @ViewChild(WeblinkAttachmentListComponent, {static: false}) modalAttachmentList: WeblinkAttachmentListComponent;

  constructor( private faultService: WeblinkFaultService, private route: ActivatedRoute ) { }

  get hasErrorFaults(): boolean {
    if(this.faults) {
      return this.faults.some( f => f.faultState===FaultState.uploadErrorActivity || f.faultState===FaultState.uploadErrorAttachment )
    } else {
      return false;
    }
  }

  @Output('selectedFaults')
  get selectedFaults(): EditableFault[] {
    if  (this.faults) {
      return this.faults.filter( fault => fault.isSelected );
    } else {
      return [];
    }
  }

  changeUser(){
    this.onChangeUser.emit(null);
  }

  get count(): number {
    return this.faults ? this.faults.length : 0;
  }

  get openFaults(): number {
    return this.faults ? this.faults.filter(f=> f.IsEditable && !f.IsClosed).length : 0;
  }

  get closedFaults(): number {
    return this.faults ? this.faults.filter(f=>!f.IsEditable || f.IsClosed).length : 0;
  }

  get tokenValidity(): string {
    return this.faultService.token.exp.toLocaleDateString();
  }

  get allSelected(): boolean {
    return this.isSelected;
  }

  set allSelected(value: boolean) {
    this.isSelected = value;
    this.faults.forEach( fault => { if (!fault.newStatus && fault.IsEditable && !fault.IsClosed) { fault.isSelected = value; }});
  }

  get faultsSelected(): boolean {
    if (this.faults) {
      return this.faults.some( fault => fault.isSelected );
    } else
    {
      return false;
    }
  }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    if (this.faults && this.faults.some(
      fault => fault.faultState !== FaultState.canEdit &&
        fault.faultState !== FaultState.cannotEdit && fault.faultState !== FaultState.synced)) {
        if (confirm('Es sind noch nicht gespeicherte Änderungen vorhanden! Diese gehen bei Ausführen der Aktion verloren! Fortfahren?')
          === false) {
            return;
          }
    }

    this.errorMessage = null;

    this.isLoading = true;
    this.data = null;
    this.faults = null;
    this.files = null;

    const token = this.route.snapshot.queryParams['t'];
    if (token) {
      this.faultService.getWeblinkFaults().subscribe( result => {

        if (!result.Settings) {
          result.Settings = new WeblinkSettings();
          // result.Settings.IsAttachmentRequired = true;
          // result.Settings.IsDescriptionRequired = true;
        }

        this.settings = result.Settings;

        this.data = result;
        this.createLayout();
        this.isLoading = false;
        let fs = (result.Faults as EditableFault[]);
        fs.forEach(fault=> {
          fault.faultState = fault.IsEditable ? FaultState.canEdit : FaultState.cannotEdit;

          if (!!fault.IsClosed) {

            //`${fault.Data.find(x => x.Key == 'LastActivitySC_Status_Name2') ?? ''}${(fault.Data.find(x => x.Key == 'LastActivitySC_Status_Name2') ? ' - ' : '')}${fault.Data.find(x => x.Key == 'LastActivitySC_Status_Name2') ?? ''}`

            const closedActivity = new Activity();
            closedActivity.Date = fault.Data.find(x => x.Key == 'LastActivitySC_Date')?.Val
            closedActivity.Description = fault.Data.find(x => x.Key == 'LastActivitySC_Description')?.Val
            closedActivity.Status = new Status();
            closedActivity.Status.Id = -9;
            closedActivity.Status.Name1 = fault.Data.find(x => x.Key == 'LastActivitySC_Status_Name1')?.Val;
            closedActivity.Status.Name2 = fault.Data.find(x => x.Key == 'LastActivitySC_Status_Name2')?.Val;

            if (closedActivity.Status?.Name1 || closedActivity.Status?.Name2) {
              fault.closedActivity = closedActivity;
            }
          }
        });

        this.faults= fs;

      },
      error => {
        this.isLoading = false;
        this.errorMessage = error;
        console.log(error);
      }
    );
    }
  }

  faultCheckChanged(event) {
    this.isSelected = this.faults.every( fault => fault.isSelected );
  }

  attachmentClick(fault:EditableFault){

    var clone = Object.create(fault);
    this.modalAttachmentList.fault= clone;


    //this.showModal= true;
    this.modalAttachmentList.initialize();
    this.modalAttachmentList.isModalOpened=true;

  }

  clickEdit() {
    this.isInEditMode = !this.isInEditMode;
  }

  editFault(fault: EditableFault, settings: WeblinkSettings) {
    this.faults.forEach((f) => {
      f.isSelected = f === fault;
    });
    this.isSelected = false;
    this.isInEditMode = true;
  }

  showLastActivity(fault: EditableFault){
    if (fault.Activities && fault.Activities[0]) {
      this.selectedActivity= fault.Activities[0];
      this.isInViewMode= true;
    }
    else if (fault.closedActivity) {
      this.selectedActivity= fault.closedActivity;
      this.isInViewMode= true;
    }
  }


  removeAttachment() {
  }

  getFiles(event) {
      this.files = event.target.files;
  }

  saveFaults() {
    this.faults.every( fault => fault.isSelected = false );
    this.faultService.addFaultsToQueue(this.faults.filter(fault => fault.faultState === FaultState.mustUpload));
  }

  sync() {
    this.faults.every( fault => fault.isSelected = false );
    const token = this.route.snapshot.queryParams['t'];
    this.faultService.addFaultsToQueue(this.faults.filter(fault =>
      fault.faultState === FaultState.uploadErrorActivity ||
      fault.faultState === FaultState.uploadErrorAttachment ||
      fault.faultState === FaultState.mustUpload));
  }

  clearSearch() {
    this.searchValue = null;
    this.searchFault(null);
  }

  searchFault(value: string) {
    this.faults.forEach(fault => {
      if(value) {
        fault.isSelected = false;
        fault.search = value;
        fault.filter = true;
        this.data.Fields.forEach(field => {
          const d = fault.Data.find( data => data.Key === field.FieldId);
          if (d) {
            const v = d.Val;

            if (v && typeof v === 'string') {
              const s = v as string;
              if(s.toLowerCase().includes(value.toLowerCase())) {
                fault.filter = false;
              }
            }
          }

        });
      } else {
        fault.filter = false;
        fault.search = null;
      }
    });
  }

  createLayout() {
    this.layout = new TileLayout();
    if(this.data) {
      if (this.data.Fields.some((obj) => obj.FieldId === 'LastImage')) {
        this.layout.hasImage = true;
      };
      let fields = this.data.Fields.filter(f => f.FieldId !== 'LastImage');
      const number = fields.filter(f => f.FieldId === 'Number');
      if(number && number.length > 0) {
        this.layout.captionProperties.push(number[0]);
        fields = fields.filter(f => f.FieldId !== 'Number');
      }
      let first = true;
      fields.forEach(f=>{
        if(first) {
          this.layout.captionProperties.push(f);
          first = false;
        } else {
          this.layout.viewProperties.push(f);
        }
      });
    }
  }

  toggleMenu() {

  }
}
